var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 12C1.99976 6.47704 6.47642 2 11.9984 2C16.0321 2 19.51 4.38894 21.0909 7.83375C21.3212 8.33571 21.9149 8.55588 22.4168 8.32553C22.9188 8.09518 23.139 7.50153 22.9086 6.99958C21.0139 2.87078 16.8424 0 11.9984 0C5.37162 0 -0.000244141 5.3727 -0.000244141 12C-0.000244141 18.6273 5.37162 24 11.9984 24C16.8424 24 21.0139 21.1292 22.9086 17.0004C23.139 16.4985 22.9188 15.9048 22.4168 15.6745C21.9149 15.4441 21.3212 15.6643 21.0909 16.1662C19.51 19.6111 16.0321 22 11.9984 22C6.47642 22 1.99976 17.523 1.99976 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6713 7.41422C13.0618 7.02369 13.695 7.02369 14.0855 7.41422L17.6211 10.9497C18.0116 11.3403 18.0116 11.9734 17.6211 12.364L14.0855 15.8995C13.695 16.29 13.0618 16.29 12.6713 15.8995C12.2808 15.509 12.2808 14.8758 12.6713 14.4853L14.5066 12.65H6.49976C5.94747 12.65 5.49976 12.2023 5.49976 11.65C5.49976 11.0977 5.94747 10.65 6.49976 10.65H14.4929L12.6713 8.82843C12.2808 8.43791 12.2808 7.80474 12.6713 7.41422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.02e108471b85540afa64b64633e5f8d1.svg";
export { ForwardRef as ReactComponent };